import React from 'react'
import * as S from './styled'
import type { PriceStringProps } from '../../functional/PriceString'
import { PriceString } from '../../functional/PriceString'

type PriceWithCurrency = PriceStringProps

export const PriceWithCurrency = (props: PriceWithCurrency) => {
  if (!props.currency) return <PriceString {...props} />

  return (
    <>
      <PriceString {...props} />
      <S.Currency>
        &nbsp;
        {props.currency}
      </S.Currency>
    </>
  )
}
